import { AuthGate, AuthServiceProvider, fetchConfig } from '@trp-ta-nitro/auth-react';
import React, { useEffect, useState } from 'react';
import { Box } from '@trp-individual-investor-adv-svc/ii-prosp-components';

import { log } from '../Utils';
import MGPWrapper from '../MGPWrapper.jsx';
import { AxiosInterceptor } from '../actions/AxiosInstance.jsx';
import Loading from './Loading';

const AuthContainer = () => {
    const [options, setOptions] = React.useState(null);
    const [isLoading, setLoading] = useState(true);

    if (window.location.href.includes("?delegateUser=")) {
        sessionStorage.setItem(
            "delegateUserId",
            window.location.href.split('?delegateUser=')[1].trim().split('&')[0].trim()
        );
    }

    if (window &&
        (window.location.pathname.indexOf('/usis/advice/fps/invite/') >= 0)) {
        const encodedUrlText = window.location.pathname.split('/').splice(-1)[0];
        log(console.log('encodedUrlText', encodedUrlText));
        sessionStorage.setItem(
            'emailInv',
            JSON.stringify({
                encodedUrlText
            })
        );
    }

    useEffect(() => {
        fetchConfig([`${window.location.origin}/usis/advice/fps/api-config.json`])
        .then(response => {
            setOptions(response);
            setLoading(false);
        })
        .catch(err => {
            setLoading(false);
            throw(err);
        });
    }, [])

    const LoadingWrapper = () => (
        <Box sx={{ height: '80vh',display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <Loading headerText="Fetching Configurations..." />
        </Box>
    )

    return isLoading ? <LoadingWrapper /> :
        (<AuthServiceProvider options={options}>
            <AuthGate externalEntitlements={[]} internalEntitlements={[['ii_adviser_ui_update'], ['su-admins']]}>
                <AxiosInterceptor>
                    <MGPWrapper applicationConfig={options} />
                </AxiosInterceptor>
            </AuthGate>
        </AuthServiceProvider>);
};

export default AuthContainer;
